import blue from "@mui/material/colors/blue";
import brown from "@mui/material/colors/brown";
import cyan from "@mui/material/colors/cyan";
import deepOrange from "@mui/material/colors/deepOrange";
import deepPurple from "@mui/material/colors/deepPurple";
import green from "@mui/material/colors/green";
import grey from "@mui/material/colors/grey";
import indigo from "@mui/material/colors/indigo";
import orange from "@mui/material/colors/orange";
import red from "@mui/material/colors/red";
import teal from "@mui/material/colors/teal";
import yellow from "@mui/material/colors/yellow";

export const primary = [
  blue[500],
  red[500],
  green[500],
  yellow[500],
  cyan[500],
  orange[500],
  teal[500],
  indigo[500],
  deepOrange[500],
  deepPurple[500],
];

export const greyscale = [
  grey[300],
  grey[400],
  grey[200],
  grey[500],
  grey[100],
  grey[600],
];

export const browns = [brown[500]];
